export const START_GET_STAFF_LIST = "START_GET_STAFF_LIST";
export const SUCCESS_GET_STAFF_LIST = "SUCCESS_GET_STAFF_LIST";
export const ERROR_GET_STAFF_LIST = "ERROR_GET_STAFF_LIST";

export const START_CREATE_STAFF = "START_CREATE_STAFF";
export const SUCCESS_CREATE_STAFF = "SUCCESS_CREATE_STAFF";
export const ERROR_CREATE_STAFF = "ERROR_CREATE_STAFF";

export const START_UPDATE_STAFF = "START_UPDATE_STAFF";
export const SUCCESS_UPDATE_STAFF = "SUCCESS_UPDATE_STAFF";
export const ERROR_UPDATE_STAFF = "ERROR_UPDATE_STAFF";

export const START_DELETE_STAFF = "START_DELETE_STAFF";
export const SUCCESS_DELETE_STAFF = "SUCCESS_DELETE_STAFF";
export const ERROR_DELETE_STAFF = "ERROR_DELETE_STAFF";

export const RESET_STAFF_STATE = "RESET_STAFF_STATE";
